import { Controller } from "@hotwired/stimulus";

// Updates a submit button's data-turbo-confirm attribute based on selected input label
//
// Usage:
//   <form data-controller="dynamic-confirm">
//     <input type="radio" name="mode" data-action="change->dynamic-confirm#update" />
//     <label>Delete everything</label>
//     <input type="checkbox" data-action="change->dynamic-confirm#update" />
//     <label>Confirm deletion</label>
//     <button data-dynamic-confirm-target="submit"
//             data-confirm-template="Are you sure you want to: %{label}?">Submit</button>
//   </form>
//
export default class extends Controller {
  static targets = ["submit"];

  connect() {
    const selectedInput = this.element.querySelector(
      'input[type="radio"]:checked, input[type="checkbox"]:checked'
    );
    if (selectedInput) {
      this.updateConfirmMessage(selectedInput);
    }
  }

  update(event) {
    this.updateConfirmMessage(event.target);
  }

  updateConfirmMessage(input) {
    const label = this.labelForInput(input);

    if (label && this.hasSubmitTarget) {
      const template = this.submitTarget.dataset.confirmTemplate || "%{label}";
      const message = template.replace("%{label}", label);
      this.submitTarget.dataset.turboConfirm = message;
    }
  }

  labelForInput(input) {
    // Try to find label by for attribute
    const id = input.id;
    if (id) {
      const label = document.querySelector(`label[for="${id}"]`);
      if (label) return label.textContent.trim();
    }

    // Try to find adjacent label (sibling)
    const parent = input.closest(".checkbox, .field, .form-group");
    if (parent) {
      const label = parent.querySelector("label");
      if (label) return label.textContent.trim();
    }

    return null;
  }
}
